import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { contextConnect } from '@wp-g2/context';
import React from 'react';
import { AccordionContext } from './Accordion.Context';
import { AccordionView } from './Accordion.styles';
import { useAccordionProps } from './useAccordion';
/**
 * @param {import('@wp-g2/create-styles').ViewOwnProps<import('./useAccordion').Props, 'div'>} props
 * @param {import('react').Ref<any>} forwardedRef
 */

function Accordion(props, forwardedRef) {
  var _useAccordionProps = useAccordionProps(props),
      children = _useAccordionProps.children,
      contextValue = _useAccordionProps.contextValue,
      otherProps = _objectWithoutProperties(_useAccordionProps, ["children", "contextValue"]);

  return /*#__PURE__*/React.createElement(AccordionContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(AccordionView, Object.assign({
    ref: forwardedRef
  }, otherProps), children));
}

export default contextConnect(Accordion, 'Accordion');